// extracted by mini-css-extract-plugin
export default {"ldsEllipsis":"Loader_ldsEllipsis__8Nfce","lds-ellipsis1":"Loader_lds-ellipsis1__UJtDM","lds-ellipsis2":"Loader_lds-ellipsis2__eMkP-","lds-ellipsis3":"Loader_lds-ellipsis3__NtEyG"};